/* global gsap */

/**
 * Sonar Perspective path animation
 * @param {Element} element - element to animate
 */
function sonarPerspective(element) {
  const timeline = gsap.timeline();

  gsap.set('.sp-circle', {opacity: 0});
  gsap.set('.sp-rectangle', {opacity: 0, scale: 0.2});
  gsap.set('#sp-circle-back', {scale: 0.2, transformOrigin: '50% 50%', xPercent: 20});
  gsap.set('#sp-circle-middle', {scale: 0.4, transformOrigin: '50% 50%', xPercent: 20});
  gsap.set('#sp-circle-front', {scale: 0.6, transformOrigin: '50% 50%', xPercent: 15});

  const squareStagger = gsap.to('.sp-rectangle', {
    stagger: -0.3,
    opacity: 1,
    scale: 1,
    yoyo: true,
    transformOrigin: '50% 50%',
  });

  const backCircleAnimation = gsap.to('#sp-circle-back', {
    opacity: 1,
    scale: 1,
    xPercent: 0,
    duration: 1,
    ease: 'easeIn',
    onComplete: function() {
      gsap.to('#sp-circle-back', {opacity: 0, duration: 0.5});
      gsap.to('#sp-circle-middle', {scale: 0.2, xPercent: 20, duration: 0, delay: 0.7});
    },
  });

  const middleCircleAnimation = gsap.to('#sp-circle-middle', {
    opacity: 1,
    scale: 1,
    xPercent: 0,
    duration: .8,
    ease: 'easeIn',
    onComplete: function() {
      gsap.to('#sp-circle-middle', {opacity: 0, duration: 0.5});
      gsap.to('#sp-circle-middle', {scale: 0.4, xPercent: 20, duration: 0, delay: 0.7});
    },
  });

  const frontCircleAnimation = gsap.to('#sp-circle-front', {
    opacity: 1,
    scale: 1,
    xPercent: 0,
    yPercent: 0,
    duration: .8,
    ease: 'easeIn',
    onComplete: function() {
      gsap.to('#sp-circle-front', {opacity: 0, duration: 0.3});
      gsap.to('.sp-rectangle', {stagger: -0.1, opacity: 0, duration: 0.3, delay: .2});
      gsap.to('#sp-circle-front', {scale: 0.6, xPercent: 15, duration: 0, delay: 0.7});
      gsap.to('.sp-rectangle', {scale: 0.2, duration: 0, delay: 0.4});
    },
  });

  const circleTimeline = gsap.timeline()
    .add(backCircleAnimation)
    .add(middleCircleAnimation, '-=.5')
    .add(frontCircleAnimation, '-=.4')
    .add(squareStagger, '-=1')
    .repeat(-1)
    .repeatDelay(1);


  timeline.add(circleTimeline);

  gsap.set(element,
    {
      rotationZ: '32deg',
    });

  gsap.to(element,
    {scrollTrigger: {
      start: '-100px 50%',
      trigger: element,
      scrub: true,
      end: '+600px 10%',
    },
    rotationZ: '-32deg',
    });
}

export {sonarPerspective};
